import { Hr } from "@/components/common/other/Hr";
import { cn } from "@/utils/css";

export const BestOutboundCardSkeleton = ({ index, withLoad = false }) => {
    return (
        <div
            className={cn(
                "flex flex-row h-[62px] border border-cm-p-outline rounded-lg bg-cm-p-surface hover:bg-cm-p-surface-hover overflow-hidden",
                {
                    "h-[104px]": withLoad,
                },
            )}
        >
            <div className="w-[22px] pt-2 bg-cm-p-container-green text-cm-p-on-container-green font-bold flex justify-center text-sm/[22px]">
                {index + 1}
            </div>
            <div className="flex flex-col w-[calc(100%-22px)]">
                <div className="flex flex-row h-[62px] w-full justify-between">
                    <div className="flex flex-col  py-2 px-[10px]">
                        <div className="h-[18px] w-[126px] bg-cm-p-surface-container rounded-xs animate-pulse mb-1" />
                        <div className="flex flex-row items-center">
                            <div className="h-[18px] w-[46px] bg-cm-p-surface-container rounded-xs animate-pulse" />
                            <div className="w-[1px] h-3 bg-cm-p-outline mx-3" />
                            <div className="h-[18px] w-[39px] bg-cm-p-surface-container rounded-xs animate-pulse" />
                        </div>
                    </div>
                    <div className="flex flex-col text-cm-p-text-secondary text-sm/[22px] py-2 justify-between pl-[10px] pr-3">
                        <div className="h-[18px] w-[52px] bg-cm-p-surface-container rounded-xs animate-pulse" />
                        <div className="flex justify-end items-center">
                            <div className="h-[18px] w-[22px] bg-cm-p-surface-container rounded-xs animate-pulse" />
                        </div>
                    </div>
                </div>
                {withLoad ? (
                    <>
                        <Hr className="mt-0 mb-[1px] mx-3 w-[calc(100%-24px)]" />
                        <div className="h-[22px] w-[calc(100%-24px)] mx-3 my-2 bg-cm-p-surface-container rounded-xs animate-pulse" />
                    </>
                ) : null}
            </div>
        </div>
    );
};
